export default __webpack_public_path__ + "static/media/drawing-man9-focusfill.2a2f1291.svg";